import { SessionDataService } from '@/services/session/session-data-service'

export interface LoginStateStore {
  isRegistered(): Promise<boolean>
}

export class SessionDataLoginStateStore implements LoginStateStore {
  isRegistered(): Promise<boolean> {
    return SessionDataService.userIsRegistered()
  }
}
